export default {
    en: {
        table: {
            img: 'Image',
            name: 'Name',
            code: "Code",
            dimensions: 'Dimensions',
            quality: 'Quality',
            quantity: "Quantity",
            color: 'Color',
            action: 'Sale'
        },
        filters: {
            title: "Filters",
            brand: { title: "Brand", all: "All" },
            size: { title: "Size", all: "All" },
            quality: { title: "Quality", all: "All" },
            color: { title: "Color", all: "All" },
            reset: "Reset",
        },
        alert: {
            title: "There are no products yet",
            content: "Let get started to creating your new product! Click add button now",
            button: "New Product"
        },
        button: "Add Product"
    },
    uz: {
        table: {
            img: 'Image',
            name: 'Name',
            code: "Code",
            dimensions: 'Dimensions',
            quality: 'Quality',
            quantity: "Quantity",
            color: 'Color',
            action: 'Sale'
        },
        filters: {
            title: "Filtrlar",
            brand: { title: "Brand", all: "Barchasi" },
            size: { title: "O'lcham", all: "Barchasi" },
            quality: { title: "Sifati", all: "Barchasi" },
            color: { title: "Rangi", all: "Barchasi" },
            reset: "Tozalash",
        },
        alert: {
            title: "Hozircha hech qanday mahsulot yo'q",
            content: "Yangi mahsulotni yaratishni boshlang!",
            button: "Yangi Mahsulot"
        },
        button: "Yangi Mahsulot"
    },
    ru: {
        table: {
            img: 'Image',
            name: 'Name',
            code: "Code",
            dimensions: 'Dimensions',
            quality: 'Quality',
            quantity: "Quantity",
            color: 'Color',
            action: 'Sale'
        },
        filters: {
            title: "Фильтры",
            brand: { title: "Марка", all: "Все" },
            size: { title: "Размеры", all: "Все" },
            quality: { title: "Качество", all: "Все" },
            color: { title: "Цвет", all: "Все" },
            reset: "Сброс",
        },
        alert: {
            title: "Там пока нет товаров.",
            content: "Давайте начнем создавать ваш новый продукт! Нажмите кнопку добавить сейчас.",
            button: "Добавить продукт"
        },
        button: "Добавить продукт"
    },
}